import axios from 'axios'
import { host } from '../../helper/config'
import { getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-banners'

export const getAll = async (token, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get`, {
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const update = async (token, id, image, status) => {
    const formData = new FormData()
    formData.append('id', id)
    formData.append('status', status)
    if (image) {
        formData.append('image', image)
    }

    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, formData, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const add = async (token, image, status) => {
    const formData = new FormData()
    formData.append('image', image)
    formData.append('status', status)

    const response = await axios.post(`${host}/${PLUGINS_NAME}/add`, formData, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const deleteBanner = async (token, id) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/delete`, {
        id: id
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}
